export const Spinner = ({ spinnerColor = "text-white" }: { spinnerColor?: string }) => {
    return (
        <output aria-label="Loading">
            <span className={`fa-solid fa-spinner fa-spin ${spinnerColor}`} aria-hidden="true"></span>
        </output>
    );
};
